import { ProductService } from '~/services/strapi/product';
import type { ApiStrapiProduct } from '~/services/strapi/product/types';

const emptyCatalog = (): ApiStrapiProduct[] => [];
export function useEquipmentCatalog() {
  const service = new ProductService();
  const catalog = useAsyncData('project-equipment', () => service.getAllProducts(), {
    default: emptyCatalog,
  });
  // Refresh on entry, including client-side navigation after a CMS publication.
  onMounted(() => {
    void catalog.refresh();
  });
  return catalog;
}
